
export const LANGUAGES = [
    { label: "العربية", value: "ar", code: "ar" },
    { label: "Deutsch", value: "de", code: "de" },
    { label: "English", value: "en", code: "en" },
    { label: "Español", value: "es", code: "es" },
    { label: "فارسی", value: "fa", code: "fa" },
    { label: "Français", value: "fr", code: "fr" },
    { label: "Italiano", value: "it", code: "it" },
    { label: "日本語", value: "ja", code: "ja" },
    { label: "Русский", value: "ru", code: "ru" },
    { label: "Türkçe", value: "tr", code: "tr" },
];

